/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo 
--------------------------------------------------------------------------------

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;
    var DropDownList = kendo.ui.DropDownList;
    if (!DropDownList || DropDownList.updated) return;

    var Widget = kendo.ui.Widget,
        AVATAR = "avatar",
        ATTR_TITLE = "title",
        ATTR_VAL_UI_TYPE = "valUi",
        proxy = $.proxy,
        NS = '.kendoDropDownList',
        DEFAULT = 'k-state-default',
        DISABLED = 'disabled',
        STATEDISABLED = 'k-state-disabled',
        ARIA_DISABLED = 'aria-disabled',
        READONLY = 'readonly',
        STATEREADONLY = "k-state-readonly",
        ARIA_READONLY = 'aria-readonly',
        HOVEREVENTS = 'mouseenter' + NS + ' mouseleave' + NS,
        TABINDEX = 'tabindex',
        FOCUSED = 'k-state-focused',
        ARROW_DOWN = 'k-i-arrow-60-down',
        ARROW_UP = 'k-i-arrow-60-up';

    /**
     * Overwrite of original editable now also moves styles and needed events to top wrapper (widget wrapper)
     */
    function dropDownListEditable(options) {
        var self = this;
        var element = self.element;
        var disable = options.disable;
        var readonly = options.readonly;
        var wrapper = self.wrapper.add(self.filterInput).off(NS);
        var dropDownWrapper = self._inputWrapper.off(HOVEREVENTS);
        if (!readonly && !disable) {
            element.prop(DISABLED, false).prop(READONLY, false);
            dropDownWrapper.removeClass(STATEREADONLY).removeClass(STATEDISABLED);
            wrapper
                .addClass(DEFAULT)
                .removeClass(STATEREADONLY)
                .removeClass(STATEDISABLED)
                .attr(TABINDEX, wrapper.data(TABINDEX))
                .attr(ARIA_DISABLED, false)
                .attr(ARIA_READONLY, false)
                .on('keydown' + NS, proxy(self._keydown, self))
                .on('focusin' + NS, function () {
                    wrapper.addClass(FOCUSED);
                    proxy(self._focusinHandler, self);
                })
                .on('focusout' + NS, function () {
                    wrapper.removeClass(FOCUSED);
                    proxy(self._focusoutHandler, self);
                })
                .on('mousedown' + NS, proxy(self._wrapperMousedown, self))
                .on('paste' + NS, proxy(self._filterPaste, self))
                .on(HOVEREVENTS, self._toggleHover);
            self.wrapper.on('click' + NS, proxy(self._wrapperClick, self));
            if (!self.filterInput) {
                wrapper.on('keypress' + NS, proxy(self._keypress, self));
            }
        } else if (disable) {
            wrapper.removeAttr(TABINDEX).addClass(STATEDISABLED).removeClass(DEFAULT).removeClass(STATEREADONLY).removeClass(FOCUSED).off(HOVEREVENTS);
            dropDownWrapper.removeClass(DEFAULT).removeClass(STATEREADONLY);
        } else {
            dropDownWrapper.removeClass(DEFAULT).removeClass(STATEDISABLED);
            wrapper
                .addClass(STATEREADONLY)
                .removeClass(DEFAULT)
                .removeClass(STATEDISABLED)
                .on('focusin' + NS, function () {
                    wrapper.addClass(FOCUSED);
                    proxy(self._focusinHandler, self);
                })
                .on('focusout' + NS, function () {
                    wrapper.removeClass(FOCUSED);
                    proxy(self._focusoutHandler, self);
                });
        }
        element.prop(DISABLED, disable).prop(READONLY, readonly);
        wrapper.attr(ARIA_DISABLED, disable).attr(ARIA_READONLY, readonly);
    }

    /**
     * The original widget "class" gets updated in two steps. First is constructor
     * update. newInit function becomes the new constructor of the component.
     * In the constructor the widget is also republished as kendo plugin, so that
     * jQuery.fn gets updated. Second step is overriding of specific widget methods
     * when needed.
     */
    var oldDropDownListInit = DropDownList.fn.init,
        newDropDownListInit = function (element, options) {
            var self = this,
                $element = $(element);
            // update options from specifically prefixed data on element
            options = kendo.elementOptions($element, "dropdownlist", options);
            if (options.enabled === undefined)
                options.enabled = !$element.is("[disabled]");
            if (options.readonly === undefined)
                options.readonly = $element.is("[readonly]");

            options.open = function (event) {
                var icon = event.sender.wrapper.find('.' + ARROW_DOWN);
                icon.toggleClass(ARROW_DOWN + ' ' +  ARROW_UP);
            };
            options.close = function(event){
                var icon = event.sender.wrapper.find('.' + ARROW_UP);
                icon.toggleClass(ARROW_DOWN + ' ' +  ARROW_UP);
            };
            // remove avatar class before the wrapper gets created
            $element.removeClass(AVATAR);
            // call original constructor
            oldDropDownListInit.call(self, element, options);
            // remember title text - needed for various description UI types
            // execute with caution to not remove the title by mistake
            self.options.titleText = self.options.titleText || self.element.attr(ATTR_TITLE);
            self.element.removeAttr(ATTR_TITLE);
            // update validation UI type in options to be sure
            self.options.validationUi = self.options.validationUi || self.element.data(ATTR_VAL_UI_TYPE);            
            // main widget wrapper custom styles
            kendo.moveCustomStylesToWrapper.call(self);
            kendo.moveRwdDataToWrapper.call(self);
            // update title / tooltip popups
            Widget.fn.descriptionUi.call(self);
            // remove input class from wrapper for easier styling
            self.wrapper.removeClass("k-input");
        };

    DropDownList = DropDownList.extend({
        // new init
        init: newDropDownListInit,
        // default options extension
        options: kendo.getUpdatedWidgetOptions(),
        _editable: dropDownListEditable
    });

    DropDownList.updated = true;

    kendo.ui.plugin(DropDownList);

})(window.kendo.jQuery);
